import { defineStore } from 'pinia'

export const useCommonStore = defineStore('common', {
  state: () => ({
    errorCode: null
  }),
  actions: {
    setErrorCode (v) {
      this.errorCode = v
    }
  }
})
